<div class="container-fluid page-container text-center pt-5">
    <lsq-circle-loader></lsq-circle-loader>
</div>
